import { render, staticRenderFns } from "./manageGoods1.vue?vue&type=template&id=4170b298&scoped=true&"
import script from "./manageGoods1.vue?vue&type=script&lang=js&"
export * from "./manageGoods1.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1.vue?vue&type=style&index=0&id=4170b298&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170b298",
  null
  
)

export default component.exports